export function CountPill({ count }: { count: number }) {
    return (
        <span className="inline-flex h-4 min-w-[16px] flex-shrink-0 items-center justify-center rounded-full bg-gray-200 px-1 text-[10px] font-bold leading-none text-gray-700 tabular-nums">
            {count}
        </span>
    );
}
